import { Trigger } from '@radix-ui/react-dialog';
import { ReactNode } from 'react';

type ModalTriggerProps = {
  children: ReactNode;
};

export const ModalTrigger = ({ children }: ModalTriggerProps) => <Trigger asChild>{children}</Trigger>;
